export const taxesEndpoints = {
  embedToken: "/jupid/embed-token/",
};
